export default "__VITE_ASSET__Cm6qiZsN__"